import * as Glob from "../../../Globale";
import * as Dati from "../../../Dati";
import * as DatiFide from "../../../DatiFide";

export const onPrint = (bozza: boolean, policy: Dati.CDatiPolizza) => {
    let database: string = Glob.StampaDatabase();

    let URL: string = Glob.StampaURL();

    let preURLBozza = "";
    if (bozza) {
        preURLBozza = "BOZ-";
    }

    URL = URL + "?SessioneMyAr=" + Glob.GetSessione().Sessione;
    URL = URL + "&Chiave=" + policy.ID_Polizza;
    URL = URL + "&Database=" + database;
    URL = URL + "&Data=" + Date.now();
    URL = URL + "&NomeFile=" + policy.TipoProdotto;

    switch (policy.ID_TipoProdotto) {
        case 1:
            URL = URL + "&Tipo=" + preURLBozza + "CADEF-";
            break;
        case 4:
            URL = URL + "&Tipo=" + preURLBozza + "CAPRO-";
            break;
        case 5:
            URL = URL + "&Tipo=" + preURLBozza + "CAANT-";
            break;
        case 6:
            URL = URL + "&Tipo=" + preURLBozza + "CARDS-";
            break;
        case 7:
            URL = URL + "&Tipo=" + preURLBozza + "CAONE-";
            break;
        case 9:
            URL = URL + "&Tipo=" + preURLBozza + "CACON-";
            break;
        case 10:
            URL = URL + "&Tipo=" + preURLBozza + "CAIVA-";
            break;
        case 11:
            URL = URL + "&Tipo=" + preURLBozza + "CA210-";
            break;
        //Iscrizione Albo rifiuti
        case 12:
            URL = URL + "&Tipo=" + preURLBozza + "CAISC-";
            break;
        //Gestione rifiuti
        case 13:
            URL = URL + "&Tipo=" + preURLBozza + "CARIF-";
            break;
        //ColtivazioneCave
        case 14:
            URL = URL + "&Tipo=" + preURLBozza + "CACOL-";
            break;
        //DaziDoganali
        case 15:
            URL = URL + "&Tipo=" + preURLBozza + "CADOG-";
            break;
        case 17:
            URL = URL + "&Tipo=" + preURLBozza + "CAPRO-";
            break;
        case 18:
            URL = URL + "&Tipo=" + preURLBozza + "CAPRO-";
            break;
        //Ripristino
        case 19:
            URL = URL + "&Tipo=" + preURLBozza + "CARIP-";
            break;
        //Attestazione capacità finanziaria autotrasportatori
        case 60:
            URL = URL + "&Tipo=" + preURLBozza + "CAACF-";
            break;
        //CAR
        case 101:
            URL = URL + "&Tipo=" + preURLBozza + "CAR-";
            let policyData = JSON.parse(policy.DatiPolizza);
            if (policyData.CExt1 || policyData.CExt2  || policyData.CExt3 || policyData.CExt4 || policyData.CExt5
                || policyData.CExt6 || policyData.CExt7 || policyData.CExt8 || policyData.CExt9 || policyData.CExt10
                || policyData.CExt11 || policyData.CExt12)
                URL += "ATTOV-";
            break;
        default:
            URL = "";
            break;
    }

    let CoAss: Dati.CDatoCoAssicurazione[] = [];
    CoAss = JSON.parse(policy.CoAssicurazioneJSON);

    let ID_BinderCompagnia: number = 0;
    for (let i: number = 0; i < CoAss.length; i++) {
        if (CoAss[i].Delegataria) {
            ID_BinderCompagnia = CoAss[i].ID_BinderCompagnia;
        }
    }

    URL += ID_BinderCompagnia + "-PDF";

    window.open(URL + "-O", "_blank", "location=yes,height=600,width=800,scrollbars=yes,status=yes");
    Glob.Log(Glob.LogCat.Stampa, false, URL + "-O");
    if (!bozza) {
        Glob.Sleep(500);
        window.open(URL + "-C", "_blank", "location=yes,height=600,width=800,scrollbars=yes,status=yes");
        Glob.Log(Glob.LogCat.Stampa, false, URL + "-C");
        Glob.Sleep(500);
        window.open(URL + "-S", "_blank", "location=yes,height=600,width=800,scrollbars=yes,status=yes");
        Glob.Log(Glob.LogCat.Stampa, false, URL + "-S");
    }
};
export const onPrintCoobligated = (
    idPolicy: string, 
    coobligated: DatiFide.CDatiFideCoobbligato[], 
    coAssicurazioneJSON: string, 
    isTemplate: boolean = false) => 
{
    let database: string = Glob.StampaDatabase();
    let baseUrl: string = Glob.StampaURL();

    baseUrl += "?SessioneMyAr=" + Glob.GetSessione().Sessione;
    baseUrl += "&Database=" + database;
    baseUrl += "&Data=" + Date.now();
    baseUrl += "&Tipo=" + "COOB-";

    let coAssicurazione: Dati.CDatoCoAssicurazione[] = [];
    coAssicurazione = JSON.parse(coAssicurazioneJSON);

    let ID_BinderCompagnia: number = 0;
    for (let i: number = 0; i < coAssicurazione.length; i++) {
        if (coAssicurazione[i].Delegataria) {
            ID_BinderCompagnia = coAssicurazione[i].ID_BinderCompagnia;
        }
    }
    
    for (let i: number = 0; i < coobligated.length; i++) {
        let url: string = baseUrl;
        if (coobligated[i].Quota >= 100) {
            if (coobligated[i].ID_TipoAnagPrincipale === "TAP-PersonaFisica")
                url += "FISICA"
            else
                url += "GIURIDICA";
        }
        else
            url += "GIURIDICAPQ";
        
        url += "-" + ID_BinderCompagnia + "-PDF";
        url += "&Chiave=" + idPolicy;
        url += "&Chiave2=" + coobligated[i].ID_Anag;
        
        if (isTemplate)
            url += "&Word=true";
        
        url += "&NomeFile=Coobligated" + i.toString();
        window.open(url, "_blank", "location=yes,height=600,width=800,scrollbars=yes,status=yes");
    }
};



// WEBPACK FOOTER //
// ./src/inar2/components/Bond/helpers.ts